/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_No_Tools_TitleInputs */



/**
* | output |
* | --- |
* | "No tools discoverable yet" |
*
* @param {Rights_Tools_No_Tools_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_no_tools_title = /** @type {((inputs?: Rights_Tools_No_Tools_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_No_Tools_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Tools ermittelbar")
	return /** @type {LocalizedString} */ ("No tools discoverable yet")
});